// Estilos sx del desglose de la factura global.
export const accordionSx = {
  heading: {
    fontSize: "0.9375rem",
    fontWeight: "bold",
    color: "#004F9F",
    marginRight: "5px",
  },
  border: {
    borderRadius: "6px",
    marginBottom: "4px",
  },
  box: {
    display: "flex",
  },
  bad: {
    background: "linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgba(246,104,94,1) 100%)",
  },
  good: {
    background: "linear-gradient(125deg, rgba(238, 238, 238 ,1) 90%, rgb(165, 255, 168) 100%)",
  },
  badInside: {
    background: "linear-gradient(90deg, rgba(238, 238, 238 ,0) 97%, rgba(246,104,94,1) 100%)",
  },
  goodInside: {
    background: "linear-gradient(90deg, rgba(238, 238, 238 ,0) 94%, rgb(165, 255, 168) 100%)",
  },
  text: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
};

// Fondo según el resultado del timbrado: sin `done` no se pinta nada.
export const doneSx = (done, goodKey, badKey) => {
  if (typeof done === "undefined" || done === null) return {};
  return accordionSx[done ? goodKey : badKey];
};
